<script lang="ts">
  import Avatar from "$components/+blocks/Avatar/Avatar.svelte";
  import OVIcon from "$components/+blocks/OVIcon/OVIcon.svelte";
  import { communitySlug } from "$stores/community";
  import { threadURL } from "$utils/urls";
  import { slugify } from "$utils/strings";
  import { CheckFilled, DashedCircle, HashTag, Right, Squircle } from "$components/+blocks/OVIcon";
  import type { ForumSpace, ForumThread } from "@outverse-video/outverse-api-client-lib";

  export let discussionThread: ForumThread;
  export let discussionItemsCount: number;

  const forumSpace = discussionThread.forumSpace as unknown as ForumSpace;
</script>

<a
  class="group flex items-center gap-1.5 px-1 pb-2 text-xs text-neutral-500/60 hover:cursor-pointer dark:text-neutral-400"
  href={threadURL({
    communitySlug: $communitySlug,
    spaceUuid: forumSpace.uuid,
    spaceSlug: slugify(forumSpace.title),
    threadUuid: discussionThread.uuid,
    threadSlug: slugify(discussionThread.title),
  })}
>
  <div class="relative size-3.5 shrink-0">
    <Avatar
      size="size-2.5"
      radius="rounded-sm"
      mainImage={discussionThread.author.profileImage}
      wrapperClasses={"bg-black/20 dark:bg-white/20 [clip-path:_polygon(0_0,_100%_0%,_100%_50%,_50%_50%,_50%_100%,_0_100%)]"}
    />
    {#if discussionThread?.solvable}
      <OVIcon
        icon={discussionThread.solution ? CheckFilled : DashedCircle}
        size="size-2.5"
        class="absolute -right-[1px] -bottom-[1px] {discussionThread.solution
          ? 'text-green-400'
          : ''}"
      />
    {:else}
      <OVIcon icon={HashTag} size="h-2.5" class="absolute -right-[1px] -bottom-[1px]" />
    {/if}
  </div>

  <span
    title={discussionThread.title}
    class="shrink-[2] truncate transition-colors group-hover:text-neutral-600 dark:group-hover:text-neutral-100"
  >
    {discussionThread.title}
  </span>

  <OVIcon icon={Right} size="h-2.5" class="mx-[1px] shrink-0" />

  <div class="mr-3 flex items-center gap-1 overflow-hidden">
    {#if forumSpace.icon}
      <Avatar mainImage={forumSpace.icon} radius="rounded-[3px]" />
    {:else}
      <span style="color: {forumSpace.color}">
        <OVIcon icon={Squircle} class="shrink-0" />
      </span>
    {/if}
    <span title={forumSpace.title} class="min-w-[6ch] truncate">
      {forumSpace.title}
    </span>
  </div>

  <div class="mr-1 ml-auto">
    {discussionItemsCount}
  </div>
</a>
